<div class="flex flex-column card">
  <app-display-detail
    *ngFor="let item of dataArray"
    [data]="item"
    [config]="config">
  </app-display-detail>
</div>
